import type {CompareItem} from '../Store';

/**
 * What the bar compares together: one category for one car. Brake pads ticked for a Porsche and
 * for a Golf are two choices, not three alternatives to weigh against each other.
 */
export const compareGroup = (item: CompareItem) => `${item.category}|${item.typeCode}`;
